module.exports = __webpack_public_path__ + "img/no-player-banner.340abcf3.jpg";